import React, { lazy } from 'react';

const LazyFooter = lazy(() => import('./Footer'));

const Footer = (props) => <LazyFooter {...props} />;

export default Footer;
